import type * as lazyIndex from './lazyIndex';
import type * as repromptCheck from './utils/showRepromptDialogIfRequired';
import {
    createLazyComponent,
    LazyAction,
    LazyImport,
    type LazyComponent,
    LazyModule,
} from 'owa-bundling';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getRepromptStore } from './store/store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "RepromptDialog" */ './lazyIndex'),
    { name: 'RepromptDialog' }
);
const fullModuleImport = new LazyImport(lazyModule, m => m);

// The boot-time check only decides whether to show a dialog; the dialog loads when shown.
const checkLazyModule: LazyModule<typeof repromptCheck> = new LazyModule(
    () =>
        isGlobalFeatureEnabled(
            'perf-memory-defer-idle-ui',
            true /* dontThrowErrorIfNotInitialized */
        ) &&
        !isGlobalFeatureEnabled(
            'perf-memory-defer-reprompt-dialog-ui-ripcord',
            true /* dontThrowErrorIfNotInitialized */
        )
            ? import(
                  /* webpackChunkName: "RepromptDialogCheck" */ './utils/showRepromptDialogIfRequired'
              )
            : fullModuleImport.import(),
    { name: 'RepromptDialogCheck' }
);

export const lazyShowRepromptDialogIfRequired: LazyAction<
    typeof lazyIndex.showRepromptDialogIfRequired,
    typeof checkLazyModule
> = new LazyAction(checkLazyModule, m => m.showRepromptDialogIfRequired);

export const RepromptDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RepromptDialog,
    undefined,
    undefined,
    {
        onlyImportIf: () => getRepromptStore().showPrivacyRepromptDialog,
    }
);

export const RepromptDialogV2: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RepromptDialogV2,
    undefined,
    undefined,
    {
        onlyImportIf: () => {
            const store = getRepromptStore();
            return (
                store.showPrivacyRepromptDialog ||
                (store.showSettingsMigrationDialog && !!store.settingsMigrationDataSource)
            );
        },
    }
);
